import MuiTableRow, { TableRowProps as MuiTableRowProps } from '@material-ui/core/TableRow';

export type DSTableRowProps = MuiTableRowProps;

export const DSTableRow = MuiTableRow;
